// extracted by mini-css-extract-plugin
export default {"container":"style_container__6ghbI","text":"style_text__I4nOU","rectangle":"style_rectangle__BSnt7","part":"style_part__9woeL"};